module.exports = __webpack_public_path__ + "static/media/file_add_black.fab95b70.svg";